var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c(
        "div",
        { attrs: { idfoevent: _vm.event.idfoevent.toString() } },
        [
          _c(
            "v-layout",
            {
              class: [
                { "odds-boost": _vm.isOddsBoost },
                _vm.event.markets[0].idfosporttype
              ],
              attrs: { "coupon-event": "" }
            },
            [
              _c(
                "div",
                { staticClass: "market" },
                [
                  _vm.isOddsBoost
                    ? _c("odds-boost-markets", {
                        staticClass: "markets-container",
                        attrs: {
                          markets: _vm.isbig3coupon
                            ? _vm.event.markets
                            : [_vm.event.markets[0]],
                          event: _vm.event,
                          iscoupondisplay: !!_vm.event.participantname_away,
                          diplayOnPage: "coupon",
                          isbig3coupon: _vm.isbig3coupon,
                          couponname: _vm.couponname,
                          isOddsBoost: _vm.isOddsBoost
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          (_vm.event.markets && _vm.event.markets[0].selections.length <= 9) ||
          !_vm.event.markets[0].isoutright
            ? _c("section", { staticClass: "single-coupon-footer" }, [
                _c("div", { staticClass: "time" }, [
                  _vm.isDateToday(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          "Today " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.event.tsstart,
                                _vm.dateFormats.longTime
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDateTomorrow(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          "Tomorrow " +
                            _vm._s(
                              _vm._f("moment")(
                                _vm.event.tsstart,
                                _vm.dateFormats.longTime
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isDateToday(_vm.event.tsstart) &&
                  !_vm.isDateTomorrow(_vm.event.tsstart)
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.event.tsstart,
                              _vm.dateFormats.longDateTimeMG
                            )
                          ) + " "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.timeZone
                    ? _c("span", [_vm._v("[" + _vm._s(_vm.timeZone) + "]")])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "highlight" }, [
      _c(
        "i",
        {
          staticClass: "icon material-icons",
          attrs: { "aria-hidden": "true" }
        },
        [_vm._v("arrow_upward")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "boost" }, [_vm._v("BOOST")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3165fc77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3165fc77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/oddsBoost/oddsBoostCouponEvent.vue
// module id = null
// module chunks = 